import './App.css';
import { ToDoBox } from './components/ToDoBox';

function App() {
  return (
    <div className="App">
      <ToDoBox />{/*Calling the main component*/}
    </div>
  );
}

export default App;
